module.exports = __webpack_public_path__ + "img/empty-2.651774ca.svg";